export const getCurrentPageName = ({ currentPageInfo }) => {
  return currentPageInfo.name?.trim() || '';
};

export const getTraversalPath = ({ currentPageInfo }) =>
  currentPageInfo.path || '';
